'use es6';

import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentLoading = () => {
  return /*#__PURE__*/_jsx(Section, {
    "data-test-id": "universal-sidebar-content-loading",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 128
    })
  });
};
export default ContentLoading;